/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import { useGlobalStore } from 'store/useGlobalStore'
import { IApiState } from 'types/baseTypes'
import shallow from 'zustand/shallow'

export const useFetch = <T>(fn: () => Promise<T>, allowedRules = [], deps = []) => {
  const isInRule = useGlobalStore((state) => state.isInRule, shallow)

  const [result, setResult] = useState<IApiState<T>>({
    loading: true
  })

  const doFetch = useCallback(async () => {
    if (!fn) return
    setResult({
      ...result,
      error: null,
      loading: true
    })

    if (allowedRules?.length > 0 && !allowedRules?.some((rule) => isInRule(rule))) {
      setResult({
        data: null,
        loading: false
      })
      return
    }

    try {
      const response = await fn()
      setResult({
        data: response,
        loading: false
      })
    } catch (error) {
      setResult({
        ...result,
        error,
        loading: false
      })
    }
  }, [fn, result])

  useEffect(() => {
    doFetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return { ...result, refetch: doFetch } as IApiState<T>
}
